import { z } from 'zod';
import { BusinessDate } from '@obraplan/core/domain/date/business-date';

/**
 * Contratos de entrada dos casos de uso.
 *
 * A validação acontece **na camada de aplicação**, não apenas no formulário: um caso de
 * uso pode ser chamado por um caminho que a interface não previa (seed, importação de
 * backup, futura automação). O formulário reutiliza estes mesmos schemas para dar
 * feedback imediato — uma única definição, dois usos.
 */

export const nonEmptyString = (field: string, max = 200) =>
  z
    .string()
    .trim()
    .min(1, `${field} é obrigatório.`)
    .max(max, `${field} deve ter no máximo ${max} caracteres.`);

export const idSchema = z.string().min(1, 'Identificador inválido.');

/** Data de negócio no formato `AAAA-MM-DD`, validada contra o calendário real. */
export const businessDateSchema = z
  .string()
  .refine((value) => BusinessDate.parse(value).ok, 'Data inválida. Use o formato AAAA-MM-DD.');

export const optionalTrimmed = (max = 1000) =>
  z
    .string()
    .trim()
    .max(max, `Deve ter no máximo ${max} caracteres.`)
    .optional()
    .transform((value) => (value === undefined || value === '' ? undefined : value));

export const paginationSchema = z.object({
  page: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(200).default(50),
});

export type Pagination = z.infer<typeof paginationSchema>;

export interface Paginated<T> {
  readonly items: readonly T[];
  readonly total: number;
  readonly page: number;
  readonly pageSize: number;
}
